import { render, staticRenderFns } from "./MyProjectCard.vue?vue&type=template&id=b1aaa076&"
import script from "./MyProjectCard.vue?vue&type=script&lang=js&"
export * from "./MyProjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports